import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-form-button',
  templateUrl: './form-button.component.html',
  styleUrls: ['./form-button.component.scss']
})
export class FormButtonComponent implements OnInit {

  @Input() title: string = '';
  @Input() size: string = 'md';
  @Input() rounded: boolean = false;
  @Input() color: string = 'primary';
  @Input() disabled: boolean = false;
  @Input() outline: boolean = true;
  
  @Input() buttonClass: any = undefined;

  @Output() clicked = new EventEmitter();

  /**
   * 
   */
  constructor() { }

  /**
   * 
   * @returns 
   */
  colorClass(): string {
    return this.color == 'primary' ? 'rtr-background-green-light' // 'primary-color-dark'
      : this.color == 'danger' ? 'danger-color'
      : this.color == 'success' ? 'rtr-background-green-light'
      : this.color == 'warning' ? 'warning-color'
      : 'secondary-color-dark';
  }


  onClick() {
   this.clicked.emit();
  }

  /**
   * 
   */
  ngOnInit(): void {
  }

}
